import { createRoot } from 'react-dom/client';
import { Page, type PageProps } from './pages/page';
import { Pending } from '@bino/utils/components/pending';
import { Suspense } from 'react';
import { createI18n, I18nProvider, formerStudents } from '@bino/utils/i18next';

const i18n = createI18n(formerStudents);

export const renderApp = (id: string, props: PageProps) => {
    const container = document.getElementById(id);
    if (!container) return;

    const root = createRoot(container);
    root.render(
        <Suspense fallback={<Pending />}>
            <I18nProvider i18n={i18n}>
                <Page {...props} />
            </I18nProvider>
        </Suspense>,
    );
};
